"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "stringToNumber", {
  enumerable: true,
  get: function () {
    return _stringToNumber.stringToNumber;
  }
});
exports.formatNumbers = void 0;

var _stringToNumber = require("./string-to-number");

const convertToLocale = (amount, locale) => {
  const rawAmount = (0, _stringToNumber.stringToNumber)(amount);
  return locale ? rawAmount.toLocaleString(locale) : rawAmount;
};

const formatNumbers = (amount, locale, prefix = '', suffix = '') => {
  if (!amount) return amount;
  return `${prefix} ${convertToLocale(amount, locale)} ${suffix}`.trim();
};

exports.formatNumbers = formatNumbers;